<template>
  <d-card class="card-small mb-3">
    <!-- Add New Input modal trigger -->
    <!-- <d-card-header class="border-bottom">
      <h6 class="m-0 d-inline">Inputs</h6>
      <button class="btn btn-primary btn-add float-right" @click="handleClick">Add New</button>
    </d-card-header>-->
    <!-- Start Inputs -->
    <d-card-body class="p-2 pt-3">
      <p class="d-inline ml-2 mb-1 font-weight-bold d-block mb-2">{{ $t('editor.inputs') }}</p>
      <div
        v-for="target_input in target_inputs"
        :key="target_input.target_input"
        class="input-draggable"
        @click="insertInput(target_input)"
      >{{ target_input }}</div>
    </d-card-body>
    <!-- <d-card-body class="p-2 pt-2">
      <p class="d-inline ml-2 mb-1 font-weight-bold d-block mb-2">My Inputs:</p>
      <div
        v-for="my_input in my_inputs"
        :key="my_input.my_input"
        class="input-draggable"
      >{{ my_input }}</div>
    </d-card-body>-->
    <!-- Modal (Add New Input) -->
    <!-- <d-modal v-if="showModal" size="lg" @close="handleClose">
      <d-modal-header>
        <d-modal-title>Add new input</d-modal-title>
      </d-modal-header>
      <d-modal-body class="pt-2">
        <div class="row mt-4">
          <div class="form-group col-md-12">
            <p>Choose an input type</p>
            <div class="custom-control custom-radio mb-3">
              <input
                type="radio"
                id="select_target_input"
                name="customRadio"
                class="custom-control-input"
                checked
              />
              <label
                class="font-weight-bold custom-control-label"
                for="select_target_input"
              >Target Inputs</label>
            </div>
            <div class="custom-control custom-radio mb-3">
              <input
                type="radio"
                id="select_my_input"
                name="customRadio"
                class="custom-control-input"
                checked
              />
              <label class="font-weight-bold custom-control-label" for="select_my_input">My Inputs</label>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="form-group col-md-6">
            <label for="feInputAddress">Input Name</label>
            <input
              id="feInputAddress"
              type="text"
              placeholder="my_company_name"
              class="form-control"
            />
          </div>
          <div class="col-md-6">
            <label for="feInputAddress">Value</label>
            <input id="feInputAddress" type="text" placeholder="Acme Co." class="form-control" />
          </div>
          <br />
        </div>
      </d-modal-body>
      <div class="modal-footer">
        <d-button size="sm" theme="danger" class="btn ml-auto">Cancel</d-button>
        <d-button size="sm" class="ml-2 btn-accent">Save</d-button>
      </div>
    </d-modal>-->
    <!-- / Modal Add New Input-->
  </d-card>
</template>

<script>
export default {
  name: "modal-add-inputs",
  data() {
    return {
      showModal: false,
      target_inputs: [
        "{{ %first_name }}",
        "{{ %last_name }}",
        "{{ %company_name }}",
        "{{ %industry }}"
      ]
      // my_inputs: ["{{ %my_name }}"]
    };
  },
  props: {},
  methods: {
    handleClick() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;
    },
    insertInput(input) {
      this.$eventHub.$emit("add-input", input);
    }
  }
};
</script>
